import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import config from '../../config';
import {
  DISCOUNT,
  DRAFT,
  MANAGE_LISTING_DISCOUNT_PAGE,
  MANAGE_LISTING_DRAFT_PAGE,
  MANAGE_LISTING_OFFERS_PAGE,
  MANAGE_LISTING_POST_PAGE,
  MANAGE_LISTING_SOLD_PAGE,
  PUBLISHED,
  SOLD,
  propTypes,
} from '../../util/types';
import css from './ManageListingsPage.module.css';
import { Button, IconCollection, Modal } from '../../components';
import Slider from 'react-slick';
import { isAnyFilterActive, isMainSearchTypeKeywords, isOriginInUse } from '../../util/search';
import { parse } from '../../util/urlHelpers';
import {
  pickSearchParamsOnly,
  validFilterParams,
  validURLParamsForExtendedData,
} from '../SearchPage/SearchPage.helpers';
import { object, shape, string } from 'prop-types';
import classNames from 'classnames';
import FilterComponent from '../SearchPage/FilterComponent';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routing/routeConfiguration';
import { getOptionsByKey, getRoute } from '../../util/dataExtractor';
import SortBy from '../SearchPage/SortBy/SortBy';
import TopbarSearchForm from '../../components/Topbar/TopbarSearchForm/TopbarSearchForm';

const FILTER_DROPDOWN_OFFSET = -14;
const cleanSearchFromConflictingParams = (searchParams, sortConfig, filterConfig) => {
  // Single out filters that should disable SortBy when an active
  // keyword search sorts the listings according to relevance.
  // In those cases, sort parameter should be removed.
  const sortingFiltersActive = isAnyFilterActive(
    sortConfig.conflictingFilters,
    searchParams,
    filterConfig
  );
  return sortingFiltersActive
    ? { ...searchParams, [sortConfig.queryParamName]: null }
    : searchParams;
};
const validUrlQueryParamsFromProps = props => {
  const { location, filterConfig } = props;
  // eslint-disable-next-line no-unused-vars
  const { mapSearch, page, ...searchInURL } = parse(location.search, {
    latlng: ['origin'],
    latlngBounds: ['bounds'],
  });
  // urlQueryParams doesn't contain page specific url params
  // like mapSearch, page or origin (origin depends on config.sortSearchByDistance)
  return {
    ...validURLParamsForExtendedData(searchInURL, filterConfig),
    pub_brand: searchInURL.pub_brand?.toString(),
  };
};

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="46"
        viewBox="0 0 26 46"
        fill="none"
      >
        <path
          d="M21.0232 22.7045L1.67351 3.42001C1.48443 3.2328 1.33502 3.00972 1.23413 2.76399C1.13324 2.51827 1.08292 2.25489 1.08615 1.98946C1.08938 1.72402 1.1461 1.46193 1.25295 1.21872C1.3598 0.975494 1.5146 0.756088 1.70818 0.573494C2.10414 0.19939 2.63107 -0.00629437 3.17699 0.000148634C3.7229 0.00659163 4.24478 0.224651 4.63172 0.607994L25.4114 21.3186C25.5994 21.5044 25.7482 21.7257 25.8493 21.9694C25.9504 22.2132 26.0016 22.4746 26 22.7383C25.9984 23.002 25.9439 23.2627 25.8399 23.5052C25.7359 23.7477 25.5843 23.9672 25.394 24.1507L3.52239 45.4134C3.13085 45.7897 2.60781 46 2.06351 46C1.51922 46 0.99618 45.7897 0.604634 45.4134C0.413318 45.2285 0.261228 45.0072 0.157371 44.7627C0.0535134 44.5183 -7.62527e-08 44.2555 -8.78549e-08 43.9901C-9.94571e-08 43.7247 0.0535134 43.462 0.157371 43.2175C0.261228 42.973 0.413318 42.7518 0.604634 42.5669L21.0232 22.7045Z"
          fill="#3065A1"
        />
      </svg>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <svg
        style={{
          transform: 'rotate(178deg)',
        }}
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="46"
        viewBox="0 0 26 46"
        fill="none"
      >
        <path
          d="M21.0232 22.7045L1.67351 3.42001C1.48443 3.2328 1.33502 3.00972 1.23413 2.76399C1.13324 2.51827 1.08292 2.25489 1.08615 1.98946C1.08938 1.72402 1.1461 1.46193 1.25295 1.21872C1.3598 0.975494 1.5146 0.756088 1.70818 0.573494C2.10414 0.19939 2.63107 -0.00629437 3.17699 0.000148634C3.7229 0.00659163 4.24478 0.224651 4.63172 0.607994L25.4114 21.3186C25.5994 21.5044 25.7482 21.7257 25.8493 21.9694C25.9504 22.2132 26.0016 22.4746 26 22.7383C25.9984 23.002 25.9439 23.2627 25.8399 23.5052C25.7359 23.7477 25.5843 23.9672 25.394 24.1507L3.52239 45.4134C3.13085 45.7897 2.60781 46 2.06351 46C1.51922 46 0.99618 45.7897 0.604634 45.4134C0.413318 45.2285 0.261228 45.0072 0.157371 44.7627C0.0535134 44.5183 -7.62527e-08 44.2555 -8.78549e-08 43.9901C-9.94571e-08 43.7247 0.0535134 43.462 0.157371 43.2175C0.261228 42.973 0.413318 42.7518 0.604634 42.5669L21.0232 22.7045Z"
          fill="#3065A1"
        />
      </svg>
    </div>
  );
}

const ManageListingsFilters = props => {
  const {
    filterConfig,
    location,
    sortConfig,
    history,
    params,
    isProfile,
    isManagePage,
    currentSearchParams,
    customListings,
    showSearch,
    isMobile,
    handleFilterData,
  } = props;

  const [isOpenFilterModal, setisOpenFilterModal] = useState(false);
  const [currentQueryParams, setcurrentQueryParams] = useState(validUrlQueryParamsFromProps(props));
  const [isMoreFilterOpen, setIsMoreFilterOpen] = useState(false);

  const onOpenFilterModal = modalValue => {
    setisOpenFilterModal(modalValue);
  };

  const brandOptions = customListings?.length && getOptionsByKey(customListings, 'brand');
  const customisedFilterOptions = {
    brandOptions,
  };
  // eslint-disable-next-line no-unused-vars
  const { mapSearch, page, keywords, ...searchInURL } = parse(location.search, {
    latlng: ['origin'],
    latlngBounds: ['bounds'],
  });
  const urlQueryParams = pickSearchParamsOnly(searchInURL, filterConfig, sortConfig);
  const validQueryParams = validURLParamsForExtendedData(searchInURL, filterConfig);
  const selectedFilters = validFilterParams(validQueryParams, filterConfig);

  useEffect(() => {
    handleFilterData(selectedFilters);
  }, []);

  const isKeywordSearch = isMainSearchTypeKeywords(config);

  const availableFilters = isKeywordSearch
    ? filterConfig.filter(f => f.type !== 'KeywordFilter')
    : filterConfig;

  const initialValues = (queryParamNames, isLiveEdit) => {
    const urlQueryParams = validUrlQueryParamsFromProps(props);

    // Query parameters that are in state (user might have not yet clicked "Apply")

    // Get initial value for a given parameter from state if its there.
    const getInitialValue = paramName => {
      const currentQueryParam = currentQueryParams[paramName];
      const hasQueryParamInState = typeof currentQueryParam !== 'undefined';
      return hasQueryParamInState && !isLiveEdit ? currentQueryParam : urlQueryParams[paramName];
    };

    // Return all the initial values related to given queryParamNames
    // InitialValues for "amenities" filter could be
    // { amenities: "has_any:towel,jacuzzi" }
    const isArray = Array.isArray(queryParamNames);
    return isArray
      ? queryParamNames.reduce((acc, paramName) => {
          return { ...acc, [paramName]: getInitialValue(paramName) };
        }, {})
      : {};
  };

  const getHandleChangedValueFn = useHistoryPush => {
    return updatedURLParams => {
      const updater = prevState => {
        const { address, bounds, keywords } = urlQueryParams;
        const mergedQueryParams = { ...urlQueryParams, ...prevState.currentQueryParams };

        // Address and bounds are handled outside of MainPanel.
        // I.e. TopbarSearchForm && search by moving the map.
        // We should always trust urlQueryParams with those.
        // The same applies to keywords, if the main search type is keyword search.
        const keywordsMaybe = isMainSearchTypeKeywords(config) ? { keywords } : {};
        return {
          currentQueryParams: {
            ...mergedQueryParams,
            ...updatedURLParams,
            ...keywordsMaybe,
            address,
            bounds,
          },
        };
      };
      setcurrentQueryParams(updater);
    };
  };

  const handleFilterSubmit = values => {
    const urlQueryParams = validUrlQueryParamsFromProps(props);
    setcurrentQueryParams(values);
    const searchParams = { ...urlQueryParams, ...values };
    const search = cleanSearchFromConflictingParams(searchParams, sortConfig, filterConfig);
    const pageRoute = getRoute(params, isProfile);
    handleFilterData(search);
    history.push(
      createResourceLocatorString(
        pageRoute,
        routeConfiguration(),
        { state: params.state, id: params.id },
        search
      )
    );
  };

  const handleSortBy = (urlParam, values) => {
    const urlQueryParams = validUrlQueryParamsFromProps(props);
    const queryParams = values
      ? { ...urlQueryParams, [urlParam]: values }
      : omit(urlQueryParams, urlParam);
    const pageRoute = getRoute(params, isProfile);
    history.push(
      createResourceLocatorString(
        pageRoute,
        routeConfiguration(),
        { state: params.state, id: params.id },
        queryParams
      )
    );
  };

  const sortBy = mode => {
    const conflictingFilterActive = isAnyFilterActive(
      sortConfig.conflictingFilters,
      validQueryParams,
      filterConfig
    );

    const mobileClassesMaybe =
      mode === 'mobile'
        ? {
            rootClassName: css.sortBy,
            menuLabelRootClassName: css.sortByMenuLabel,
          }
        : { className: css.sortByDesktop };
    return sortConfig.active ? (
      <SortBy
        {...mobileClassesMaybe}
        sort={validQueryParams[sortConfig.queryParamName]}
        isConflictingFilterActive={!!conflictingFilterActive}
        hasConflictingFilters={!!(sortConfig.conflictingFilters?.length > 0)}
        selectedFilters={selectedFilters}
        onSelect={handleSortBy}
        showAsPopup={false}
        contentPlacementOffset={FILTER_DROPDOWN_OFFSET}
        modalView={true}
        onOpenFilterModal={onOpenFilterModal}
      />
    ) : null;
  };
  const handleSubmit = values => {
    const topbarSearchParams = () => {
      if (isMainSearchTypeKeywords(config)) {
        return { keywords: values?.keywords };
      }
      // topbar search defaults to 'location' search
      const { search, selectedPlace } = values?.location;
      const { origin, bounds } = selectedPlace;
      const originMaybe = isOriginInUse(config) ? { origin } : {};

      return {
        ...originMaybe,
        address: search,
        bounds,
      };
    };
    const searchParams = {
      ...currentSearchParams,
      pub_listingStore: values?.keywords,
    };
    const pageRoute = getRoute(params, isProfile);

    history.push(
      createResourceLocatorString(
        pageRoute,
        routeConfiguration(),
        { state: params.state, id: params.id },
        searchParams
      )
    );
  };
  const topbarSearcInitialValues = () => {
    if (isMainSearchTypeKeywords(config)) {
      return { keywords };
    }

    // Only render current search if full place object is available in the URL params
    const locationFieldsPresent = isOriginInUse(config)
      ? address && origin && bounds
      : address && bounds;
    return {
      location: locationFieldsPresent
        ? {
            search: address,
            selectedPlace: { address, origin, bounds },
          }
        : null,
    };
  };
  const initialSearchFormValues = topbarSearcInitialValues();
  const search = (
    <TopbarSearchForm
      className={css.searchLink}
      desktopInputRoot={css.topbarSearchWithLeftPadding}
      onSubmit={handleSubmit}
      initialValues={initialSearchFormValues}
      appConfig={config}
      manageListingPageSearch={true}
    />
  );

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1260,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <div>
      {showSearch ? (
        search
      ) : (
        <div className={css.layoutWrapperFilterColumn}>
          <div
            className={classNames(
              css.filterColumnContent,
              isOpenFilterModal && css.filterModalOpen
            )}
          >
            {isMobile ? (
              <>
                {isMoreFilterOpen ? (
                  <Modal
                    className={css.modalStores}
                    isOpen={isMoreFilterOpen}
                    onClose={() => {
                      setIsMoreFilterOpen(false);
                    }}
                    onManageDisableScrolling={() => {}}
                  >
                    <div className={css} style={{ marginBottom: '25px' }}>
                      More Filter{' '}
                    </div>
                    <div className={css.moreFilterDiv}>
                      {availableFilters.map(
                        config =>
                          config.label !== 'Category' &&
                          config.label !== 'Size' && (
                            <FilterComponent
                              key={`SearchFiltersMobile.${config.id}`}
                              isManagePage={isManagePage}
                              isMoreFilterOpen={isMoreFilterOpen}
                              customisedFilterOptions={customisedFilterOptions}
                              isProfile={isProfile}
                              isManagePageFilter={true}
                              params={params}
                              idPrefix="SearchFiltersMobile"
                              filterConfig={config}
                              className={css.morefilter}
                              validQueryParams={validQueryParams}
                              urlQueryParams={urlQueryParams}
                              initialValues={initialValues}
                              getHandleChangedValueFn={getHandleChangedValueFn}
                              history={history}
                              handleFilterSubmit={handleFilterSubmit}
                              liveEdit
                              showAsPopup={false}
                              isDesktop
                              onOpenFilterModal={onOpenFilterModal}
                              onManageDisableScrolling={() => {}}
                            />
                          )
                      )}
                      <div className={css.showScarchResult}>
                        <Button
                          rClassName={css.filtersButtonSelected}
                          onClick={() => {
                            setIsMoreFilterOpen(false);
                          }}
                        >
                          <FormattedMessage
                            id="SearchFiltersMobile.showResults"
                            className={css.mapIconText}
                          />
                        </Button>
                      </div>
                    </div>
                  </Modal>
                ) : (
                  <>
                    {availableFilters.map(
                      config =>
                        (config.label === 'Category' || config.label === 'Size') && (
                          <FilterComponent
                            key={`SearchFiltersMobile.${config.id}`}
                            isManagePage={isManagePage}
                            isMoreFilterOpen={isMoreFilterOpen}
                            customisedFilterOptions={customisedFilterOptions}
                            isProfile={isProfile}
                            isManagePageFilter={true}
                            params={params}
                            idPrefix="SearchFiltersMobile"
                            filterConfig={config}
                            className={css.filter}
                            validQueryParams={validQueryParams}
                            urlQueryParams={urlQueryParams}
                            initialValues={initialValues}
                            getHandleChangedValueFn={getHandleChangedValueFn}
                            history={history}
                            handleFilterSubmit={handleFilterSubmit}
                            liveEdit
                            showAsPopup={false}
                            isDesktop
                            onOpenFilterModal={onOpenFilterModal}
                            onManageDisableScrolling={() => {}}
                          />
                        )
                    )}
                    <div className={css.buttons}>
                      <Button
                        rClassName={css.filtersButtonSelected}
                        onClick={() => {
                          setIsMoreFilterOpen(true);
                        }}
                      >
                        <IconCollection icon="IconFilter" />
                        <FormattedMessage
                          id="SearchFiltersMobile.filtersButtonLabel"
                          className={css.mapIconText}
                        />
                      </Button>
                    </div>
                  </>
                )}
              </>
            ) : (
              <Slider {...settings}>
                {sortBy('desktop')}
                {availableFilters.map(
                  config =>
                    config.label !== 'Sub Category' && (
                      <FilterComponent
                        key={`SearchFiltersMobile.${config.id}`}
                        isManagePage={isManagePage}
                        customisedFilterOptions={customisedFilterOptions}
                        isProfile={isProfile}
                        isMoreFilterOpen={isMoreFilterOpen}
                        isManagePageFilter={true}
                        params={params}
                        idPrefix="SearchFiltersMobile"
                        filterConfig={config}
                        className={css.filter}
                        validQueryParams={validQueryParams}
                        urlQueryParams={urlQueryParams}
                        initialValues={initialValues}
                        getHandleChangedValueFn={getHandleChangedValueFn}
                        history={history}
                        handleFilterSubmit={handleFilterSubmit}
                        liveEdit
                        showAsPopup={false}
                        isDesktop
                        onOpenFilterModal={onOpenFilterModal}
                        onManageDisableScrolling={() => {}}
                      />
                    )
                )}
              </Slider>
            )}
            {/* <button className={css.resetAllButton} onClick={e => this.handleResetAll(e)}>
                <FormattedMessage id={'SearchFiltersMobile.resetAll'} />
              </button> */}
          </div>
        </div>
      )}
    </div>
  );
};
ManageListingsFilters.defaultProps = {
  filterConfig: config.custom.filters,
  sortConfig: config.custom.sortConfig,
  currentSearchParams: null,
};

ManageListingsFilters.propTypes = {
  filterConfig: propTypes.filterConfig,
  sortConfig: propTypes.sortConfig,
  currentSearchParams: object,
};
export default ManageListingsFilters;
